import type { App } from "vue";
import VueLazyload from "vue-lazyload";

export default {
  install(app: App) {
    app.use(VueLazyload, {
      preLoad: 1.3,
      attempt: 1,
      adapter: {
        loading(listener: any) {
          const { el } = listener;
          // 如果 当前dom配置有data-loading则不使用默认的错误图
          const loadingSrc = el.dataset.loading;
          el.src = loadingSrc || require("@img/bg-default.png");
        },
        error(listener: any) {
          const { el } = listener;
          const errorSrc = el.dataset.error;
          // 如果 当前dom配置有data-error则不使用默认的错误图
          el.src = errorSrc || require("@img/bg-default.png");
        },
      },
    });
  },
};
